import styled from "@emotion/styled";

export const FlexibleRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin: 0px auto;
  color: white;
  gap: 20px; 


  @media (max-width: 780px) {
    flex-direction: column;
    align-items: center;
  }


  width: 90%;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
`;
